import ActionTypes from '../constants';

const initialState = {
    vehicleReplacements: {},
    vehicleReplacement: {},
    leaseCompanies: {},
    driverVehicles: {},
    technicalReport: {},
};

const vehicleReplacementReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GETVEHICLEREPLACEMENTSUCCESS:
            return {
                ...state,
                vehicleReplacements: action.payload,
            }
        case ActionTypes.GETVEHICLEREPLACEMENTBYIDSUCCESS:
            return {
                ...state,
                vehicleReplacement: action.payload,
            }
        case ActionTypes.GETTECHNICALREPORTBYIDSUCCESS:
            return {
                ...state,
                technicalReport: action.payload,
            }
        case ActionTypes.GETVEHICLEREPLACEMENTBYDRIVERIDSUCCESS:
            return {
                ...state,
                driverVehicles: action.payload,
            }
        case ActionTypes.GETLEASEPLANSUCCESS:
            return {
                ...state,
                leaseCompanies: action.payload,
            }
        default:
            return state;
    }
}

export default vehicleReplacementReducer;